import React from 'react'
import InputCustom from 'components/Inputs'
import { FiTrash } from 'react-icons/fi'
import { RiIncreaseDecreaseLine } from 'react-icons/ri'
import { Col, Collapse, Row } from 'reactstrap'
import { SimpleTitleCard } from 'styles/global'
import CardParametrizacao from './CardParametrizacao'
import { BiChevronDown } from 'react-icons/bi'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { PRODUTO } from 'store/modules/backoffice/produto/types'
import { ParametrizacaoProdutoReq } from 'models/backoffice/produto/type'
import * as produtoActions from 'store/modules/backoffice/produto/actions'
import useRedux from 'hooks/useRedux'
import { maskMoney } from 'util/masks'

const CardValorMargem = () => {
  const { register, visualizacao, cardsState, invalids } = useSelector<
    ApplicationState,
    PRODUTO
  >((state) => state.produto)

  const { dispatch } = useRedux()

  type Field = keyof ParametrizacaoProdutoReq

  function onChange(value: string | number, field: Field) {
    dispatch(produtoActions.setRegister({ ...register, [field]: value }))
  }

  function onToggle() {
    dispatch(produtoActions.toggleCard(!cardsState.valorMargem, 'valorMargem'))
  }

  return (
    <CardParametrizacao>
      <div className="d-flex justify-content-between">
        <SimpleTitleCard color="#000" colorIcon="#000">
          <RiIncreaseDecreaseLine className="icon" />
          Valor de Margem
        </SimpleTitleCard>
        <BiChevronDown onClick={() => onToggle()} className="toggler" />
      </div>
      <Collapse isOpen={cardsState.valorMargem}>
        <div className="d-flex flex-column row-gap-10">
          <Row>
            <Col md={4}>
              <label className="label-12">De: (em R$)</label>
              <InputCustom
                type="text"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(maskMoney(e.target.value), 'margemMin')
                }}
                value={register.margemMin || ''}
                disabled={visualizacao}
                maxLength={14}
                invalid={invalids.margemMin}
              />
            </Col>
            <Col md={4}>
              <label className="label-12">Até: (em R$)</label>
              <InputCustom
                type="text"
                placeholder="Digite aqui"
                onChange={(e) => {
                  onChange(maskMoney(e.target.value), 'margemMax')
                }}
                value={register.margemMax || ''}
                disabled={visualizacao}
                maxLength={14}
                invalid={invalids.margemMax}
              />
            </Col>
          </Row>
          <div className="linha-horizontal"></div>
          {!visualizacao && (
            <Row>
              <Col className="d-flex justify-content-end">
                <FiTrash
                  onClick={() => dispatch(produtoActions.cleanValorMargem())}
                  className="icon-trash"
                />
              </Col>
            </Row>
          )}
        </div>
      </Collapse>
    </CardParametrizacao>
  )
}

export default CardValorMargem
